import Slider from "../Slider/Slider";
import Product from "../Product/Product";
import Tintuc from "../Tintuc/Tintuc";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";

export default function Home() {
  return (
    <div>
      <Navbar />
      <Slider />
      <Product />
      <Tintuc />
      <Footer />
    </div>
  );
}
